const JiraValidationService = () => ({
  handleSync: ({
    selectedProviderIds,
    doSync,
    sensorAuth,
    setIterationsData,
    setIsLoadingIterations
  }) => {
    if (selectedProviderIds.length) {
      doSync(sensorAuth, selectedProviderIds);
    } else {
      setIterationsData([]);
      setIsLoadingIterations(false);
    }
  },
  isSyncPerEntity: true
});

export default JiraValidationService;
